import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export const AngleDown = ({ ...rest }) => {
  return <FontAwesomeIcon icon={["fa", "angle-down"]} {...rest} />;
};
